import React from 'react'
import { Space } from 'antd'
import { ProfileHeader } from '../components/ProfileHeader'
import { PersonalInfoForm } from '../components/PersonalInfoForm'
import { SecuritySettings } from '../components/SecuritySettings'
import { ActivityLog } from '../components/ActivityLog'

export const ProfileScreen: React.FC = () => {
    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <ProfileHeader />
            <PersonalInfoForm />
            <SecuritySettings />
            <ActivityLog />
        </Space>
    )
}
